import { Box, Button, Image, Text } from "@chakra-ui/react";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import ReactImageUploading from "react-images-uploading";
import CloseIcon from "components/Icons/PropertyIcon/CloseIcon.svg";
import { applyCenterWatermarkAndUpload, applyWatermarkAndUpload, deleteMediaFromS3Bucket, uploadMediaToS3Bucket } from "services/awsHelper";
import FullscreenImageViewer from "components/fullScreenImageViewer";

const MultipleImagesComponent = ({ imagesArray = [], width = "100%", height = "auto", title, updateImagesFunction, waterMarkPermissions = 'Default' }, ref) => {

    const [images, setImages] = useState([]);
    const [isViewerOpen, setViewerOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    useEffect(() => {
        if (imagesArray.length) {
            debugger;
            const tempImageList = imagesArray.map((imageURL) => {
                return {
                    key: imageURL,
                    data_url: process.env.REACT_APP_IMAGE_API_URL + imageURL,
                };
            });
            setImages(tempImageList);
        }

    }, [imagesArray])

    const handleImageUploadChange = (imageList) => {
        const ImagesList = imageList.map((image, index) => {
            if (image.file) {
                let nameArray = image.file.name.split(".");
                let key = `${nameArray[0]}_${Date.now()}_${index}.webp`;
                return { ...image, key }
            } else {
                return image;
            }
        })

        setImages([...ImagesList]);

        const updatedInitialImageArray = [...ImagesList].map(image => image.key)
        updateImagesFunction(updatedInitialImageArray);

    }

    const triggerUpload = async () => {
        const uploadToS3Array = images.filter(image => image.file);
        const imagesKeySet = new Set(images.map(image => image.key));
        const deleteFromS3Array = imagesArray.filter(key => !imagesKeySet.has(key));

        switch (waterMarkPermissions) {
            case "CenterOnly":
                await applyCenterWatermarkAndUpload(uploadToS3Array)
                break;
            case "CenterAndBottomOnly":
                await applyWatermarkAndUpload(uploadToS3Array)
                break;

            default:
                await uploadMediaToS3Bucket(uploadToS3Array);
                break;
        }

        deleteFromS3Array.forEach(key => {
            deleteMediaFromS3Bucket(key);
        });
    };

    useImperativeHandle(ref, () => ({
        triggerUpload,
    }));

    return (
        <>
            <Box w={width} h={"fit-content"}>
                <Text variant={"secondary14"} mb={"6px"}> {title} </Text>
                <ReactImageUploading
                    multiple
                    value={images}
                    onChange={handleImageUploadChange}
                    dataURLKey="data_url"
                >
                    {({
                        imageList,
                        onImageUpload,
                        onImageUpdate,
                        onImageRemove,
                        dragProps,
                    }) => (
                        <Box
                            border={"1px solid #ccc"}
                            borderRadius={"8px"}
                            p={"8px"}
                            display={"flex"}
                            className="upload__image-wrapper"
                            w={"100%"}
                            minH={"max-content"}
                        >
                            <Button
                                border={"1px solid #ccc"}
                                _focus={"1px solid #ccc "}
                                borderRadius={"8px"}
                                h={"80px"}
                                w={"80px"}
                                color={"#212121"}
                                fontSize={"24px"}
                                mr={"8px"}
                                onClick={onImageUpload}
                                {...dragProps}
                            >
                                +
                            </Button>
                            <Box
                                borderLeft={"1px solid #ccc"}
                                p={"0px 0px 0px 8px"}
                                display={"flex"}
                                alignItems={"center"}
                                flexWrap={"wrap"}
                                gap={"15px"}
                            >
                                {imageList.map((image, index) => (
                                    <>
                                        <Box
                                            key={index}
                                            position={"relative"}
                                            mr={"8px"}
                                            minW={"10%"}
                                        >
                                            <Image
                                                boxSize={"80px"}
                                                src={image.data_url}
                                                borderRadius={"8px"}
                                                onClick={() => {
                                                    setSelectedIndex(index);
                                                    setViewerOpen(true);
                                                }}
                                                cursor="pointer"
                                            />
                                            <Box
                                                position={"absolute"}
                                                top={"2px"}
                                                right={"2px"}
                                                bgColor={"#ffffff"}
                                                borderRadius={"20px"}
                                                cursor={"pointer"}
                                                onClick={() => { onImageRemove(index) }}
                                            >
                                                <Image src={CloseIcon} />
                                            </Box>
                                        </Box>
                                    </>
                                ))}
                            </Box>
                        </Box>
                    )}
                </ReactImageUploading>
            </Box>
            <FullscreenImageViewer
                images={images.map(img => img.data_url)}
                initialIndex={selectedIndex}
                isOpen={isViewerOpen}
                onClose={() => setViewerOpen(false)}
            />
        </>
    )
}

export default forwardRef(MultipleImagesComponent);